import LocationForm from './LocationForm';
import './LocationForm.scss';

export default LocationForm;
